angular.module("charts")
    .directive("dblStudentGrowthOverview", [function() {
        return {
            restrict: "E",
            templateUrl: '/resources/charts/directives/student-growth-overview/dbl-student-growth-overview.directive.html',
            scope: {
                dblGrowth: '=',
                dblStandardsNames: '=' // object containing names of completed and in-progress standards that had growth
            },
            link: function(scope, element) {
                var buildStandardsHtml = function (standardsNames) {
                    if (standardsNames) {
                        return standardsNames.join('<br>');
                    }
                };

                scope.getCompletedStandardsHtml = function () {
                    if (scope.dblStandardsNames) {
                        return buildStandardsHtml(scope.dblStandardsNames.completed);
                    }
                };

                scope.getInProgressStandardsHtml = function () {
                    if (scope.dblStandardsNames) {
                        return buildStandardsHtml(scope.dblStandardsNames.inProgress);
                    }
                };

            }
        };
    }]);
